export default __webpack_public_path__ + "static/media/customer3.a40e9708.png";